(() => {
  const infiniteScrollSections = document.querySelectorAll('[data-collection-infinite-scroll]');
  const supportsWorkerInfiniteScroll = 'IntersectionObserver' in window && 'fetch' in window;
  const supportsNativeInfiniteScroll = supportsWorkerInfiniteScroll && 'DOMParser' in window;
  const infiniteScrollPreloadMargin = 900;
  const infiniteScrollRootMargin = `${infiniteScrollPreloadMargin}px 0px`;
  const productImageSizes = '(min-width: 1750px) 330px, (min-width: 990px) calc((100vw - 8rem) / 5), (min-width: 750px) calc((100vw - 4rem) / 3), calc((100vw - 3rem) / 2)';
  const customColorFilterParam = 'filter.v.option.color';
  const customWashColorValues = new Set([
    'Black Wash',
    'Dark Wash',
    'Grey Wash',
    'Light Wash',
    'Medium Wash'
  ]);
  const customColorAliases = {
    avocado: 'Green',
    beige: 'Natural',
    black: 'Black',
    'black wash': 'Black Wash',
    blue: 'Blue',
    blush: 'Pink',
    brown: 'Brown',
    burgundy: 'Red',
    butter: 'Yellow',
    camel: 'Brown',
    cerulean: 'Blue',
    charcoal: 'Grey',
    chartreuse: 'Yellow',
    chocolate: 'Brown',
    cocoa: 'Brown',
    coral: 'Orange',
    cranberry: 'Red',
    'cotton candy': 'Pink',
    cream: 'Natural',
    cyan: 'Blue',
    daisy: 'Yellow',
    'dark wash': 'Dark Wash',
    'deep magenta': 'Pink',
    denim: 'Medium Wash',
    espresso: 'Brown',
    forest: 'Green',
    fuchsia: 'Pink',
    gold: 'Gold',
    gray: 'Grey',
    'gray wash': 'Grey Wash',
    green: 'Green',
    grey: 'Grey',
    'grey wash': 'Grey Wash',
    ivory: 'White',
    khaki: 'Natural',
    indigo: 'Blue',
    lavender: 'Purple',
    latte: 'Brown',
    lemon: 'Yellow',
    limoncello: 'Yellow',
    'light wash': 'Light Wash',
    lilac: 'Purple',
    medium: 'Medium Wash',
    'medium wash': 'Medium Wash',
    mint: 'Green',
    mocha: 'Brown',
    multi: 'Multi',
    mustard: 'Yellow',
    natural: 'Natural',
    navy: 'Blue',
    oatmeal: 'Natural',
    olive: 'Green',
    orange: 'Orange',
    'pale mauve': 'Purple',
    pecan: 'Brown',
    petal: 'Pink',
    pink: 'Pink',
    purple: 'Purple',
    raspberry: 'Pink',
    red: 'Red',
    rust: 'Orange',
    sage: 'Green',
    scarlet: 'Red',
    smoky: 'Brown',
    'smoky taupe': 'Brown',
    stone: 'Grey',
    spruce: 'Green',
    sunflower: 'Yellow',
    tan: 'Natural',
    taupe: 'Brown',
    vanilla: 'Natural',
    white: 'White',
    wine: 'Red',
    yellow: 'Yellow'
  };

  const getInfiniteScrollNextLink = (root) => {
    return root.querySelector('[data-collection-pagination] a[rel="next"]');
  };

  const setInfiniteScrollStatus = (status, message = '') => {
    if (!status) return;

    status.textContent = message;
  };

  const normalizeLoadedProductImages = (card) => {
    card.querySelectorAll('img').forEach((image) => {
      image.loading = 'lazy';
      image.removeAttribute('fetchpriority');
    });
  };

  const escapeHtml = (value) => {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const safeJson = (value) => {
    return JSON.stringify(value).replace(/</g, '\\u003c');
  };

  const handleize = (value) => {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const normalizeCustomColor = (value) => {
    const raw = String(value || '').trim();
    const key = raw.toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');

    if (!raw) return '';
    return customColorAliases[key] || raw.replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
  };

  const getCustomColorValuesFromLocation = () => {
    const params = new URLSearchParams(window.location.search);
    const values = [
      ...params.getAll(customColorFilterParam),
      ...params.getAll('colorFilter').flatMap((value) => String(value || '').split(','))
    ];

    return Array.from(new Set(values.map(normalizeCustomColor).filter(Boolean)));
  };

  const removeCustomColorUrl = (color) => {
    const params = new URLSearchParams(window.location.search);
    const normalizedColor = normalizeCustomColor(color).toLowerCase();
    const nextValues = params.getAll(customColorFilterParam).filter((value) => {
      return normalizeCustomColor(value).toLowerCase() !== normalizedColor;
    });

    params.delete(customColorFilterParam);
    nextValues.forEach((value) => params.append(customColorFilterParam, value));

    const query = params.toString();

    return `${window.location.pathname}${query ? `?${query}` : ''}`;
  };

  const updateCustomActiveCount = (form, customColorCount) => {
    const baseCount = Number(form.dataset.collectionBaseActiveCount || 0);
    const total = baseCount + customColorCount;
    const countShell = form.querySelector('[data-collection-active-count]');
    const countNumber = form.querySelector('[data-collection-active-count-number]');
    const drawerCount = form.querySelector('[data-collection-drawer-count]');

    if (countNumber) countNumber.textContent = String(total);
    if (drawerCount) drawerCount.textContent = String(total);

    countShell?.classList.toggle('is-hidden', total === 0);
    drawerCount?.classList.toggle('is-hidden', total === 0);
  };

  const getFilterIcon = (form, icon) => {
    return form.querySelector(`template[data-collection-filter-icon="${icon}"]`)?.innerHTML.trim() || '';
  };

  const updateCustomColorFilterState = (form) => {
    const selectedColors = getCustomColorValuesFromLocation();
    const selectedSet = new Set(selectedColors.map((color) => color.toLowerCase()));
    const inputs = Array.from(form.querySelectorAll('[data-custom-color-filter]'));
    const activeContainer = form.querySelector('[data-custom-color-active-filters]');
    const colorCount = form.querySelector('[data-custom-color-filter-count]');

    inputs.forEach((input) => {
      const normalizedValue = normalizeCustomColor(input.value);
      const isSelected = selectedSet.has(normalizedValue.toLowerCase());
      const label = input.closest('[data-custom-color-filter-label]');

      input.checked = isSelected;
      label?.classList.toggle('filter-swatch--active', isSelected);
    });

    if (colorCount) {
      colorCount.textContent = String(selectedColors.length);
      colorCount.classList.toggle('is-hidden', selectedColors.length === 0);
    }

    if (activeContainer) {
      activeContainer.hidden = selectedColors.length === 0;
      activeContainer.innerHTML = selectedColors.map((color) => `
        <a class="collection-active-filter" href="${escapeHtml(removeCustomColorUrl(color))}">
          <span>${escapeHtml(color)}</span>
          ${getFilterIcon(form, 'close')}
        </a>
      `).join('');
    }

    updateCustomActiveCount(form, selectedColors.length);
  };

  const updateCustomColorFilterCounts = (root, colorFacets = {}) => {
    const form = root.closest('.collection-template')?.querySelector('[data-collection-filter-form]');

    if (!form) return;

    const normalizedFacets = Object.entries(colorFacets || {}).reduce((counts, [color, count]) => {
      counts[normalizeCustomColor(color).toLowerCase()] = Number(count || 0);
      return counts;
    }, {});

    form.querySelectorAll('[data-custom-color-filter]').forEach((input) => {
      const label = input.closest('[data-custom-color-filter-label]');
      const count = Number(normalizedFacets[normalizeCustomColor(input.value).toLowerCase()] || 0);
      const countElement = label?.querySelector('[data-custom-color-filter-option-count]');
      const isWashColor = customWashColorValues.has(input.value);

      input.disabled = !isWashColor && count === 0 && !input.checked;
      if (countElement) countElement.textContent = String(count);
    });
  };

  const normalizeImageUrl = (url) => {
    if (!url) return '';

    return String(url).startsWith('//') ? `${window.location.protocol}${url}` : String(url);
  };

  const withImageWidth = (url, width) => {
    const normalizedUrl = normalizeImageUrl(url);
    if (!normalizedUrl) return '';

    try {
      const parsedUrl = new URL(normalizedUrl, window.location.origin);
      parsedUrl.searchParams.set('width', String(width));
      return parsedUrl.toString();
    } catch (error) {
      const separator = normalizedUrl.includes('?') ? '&' : '?';

      return `${normalizedUrl}${separator}width=${width}`;
    }
  };

  const buildSrcset = (url) => {
    return [320, 540, 760]
      .map((width) => `${withImageWidth(url, width)} ${width}w`)
      .join(', ');
  };

  const moneyAmount = (money) => {
    const amount = Number(money?.amount ?? money ?? 0);

    return Number.isFinite(amount) ? amount : 0;
  };

  const formatMoney = (amount, currencyCode = 'USD') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currencyCode
      }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  const getOptionName = (option) => {
    return typeof option === 'string' ? option : option?.name || '';
  };

  const getVariantOptionValue = (variant, optionName) => {
    return (variant?.selectedOptions || []).find((option) => option.name === optionName)?.value || '';
  };

  const getVariantOptions = (variant) => {
    return (variant?.selectedOptions || []).map((option) => option.value).filter(Boolean);
  };

  const getVariantNumericId = (variantOrId) => {
    const id = typeof variantOrId === 'object' ? (variantOrId?.numericId || variantOrId?.id) : variantOrId;
    const match = String(id || '').match(/(\d+)$/);

    return match ? match[1] : String(id || '');
  };

  const isVariantAvailable = (variant) => {
    return Boolean(variant?.availableForSale || variant?.available);
  };

  const getVisibleVariants = (product) => {
    return (product?.variants || []).filter((variant) => !variant.hidden);
  };

  const getSelectedVariant = (product) => {
    const variants = getVisibleVariants(product);
    const selectedVariantId = String(product?.selectedVariantId || '');

    return variants.find((variant) => String(variant.id) === selectedVariantId)
      || variants.find((variant) => getVariantNumericId(variant) === selectedVariantId)
      || variants.find(isVariantAvailable)
      || variants[0]
      || null;
  };

  const getSwatchStyle = (value) => {
    return window.WobSwatches?.getSwatchStyle?.(value) || '--swatch-color: #d9d9d9;';
  };

  const getSwatchLabel = (value) => {
    return window.WobSwatches?.getSwatchLabel?.(value) || String(value || '');
  };

  const getIcon = (root, icon) => {
    return root.querySelector(`template[data-collection-worker-icon="${icon}"]`)?.innerHTML.trim() || '';
  };

  const getCollectionProductUrl = (root, url = '', productHandle = '') => {
    const collectionHandle = root.dataset.collectionHandle || '';
    const fallbackUrl = url || (productHandle ? `/products/${productHandle}` : '');

    if (!collectionHandle || !fallbackUrl) return fallbackUrl;

    try {
      const parsedUrl = new URL(fallbackUrl, window.location.origin);
      const productMatch = parsedUrl.pathname.match(/\/products\/([^/]+)/);
      const handle = productMatch?.[1] || productHandle || '';

      if (!handle) return fallbackUrl;

      return `/collections/${encodeURIComponent(collectionHandle)}/products/${encodeURIComponent(handle)}${parsedUrl.search}`;
    } catch (error) {
      return fallbackUrl;
    }
  };

  const renderPrice = (root, product) => {
    const currencyCode = product?.priceRange?.minVariantPrice?.currencyCode || root.dataset.currencyCode || 'USD';
    const price = moneyAmount(product?.priceRange?.minVariantPrice);
    const maxPrice = moneyAmount(product?.priceRange?.maxVariantPrice);
    const compareAtPrice = moneyAmount(product?.compareAtPriceRange?.maxVariantPrice);
    const showFrom = maxPrice > price;
    const onSale = compareAtPrice > price;
    const soldOut = !product?.availableForSale;
    // Color cards price their own color, so their selected variant is the reference.
    const selectedVariant = (product?.splitColor ? getSelectedVariant(product) : null)
      || (product?.variants || []).find((variant) => moneyAmount(variant?.price) === price)
      || getSelectedVariant(product);
    const productId = product?.numericId || product?.id || '';
    const variantId = getVariantNumericId(selectedVariant);

    return `
      <div class="price${onSale ? ' price--on-sale' : ''}${soldOut ? ' price--sold-out' : ''}" data-price data-product-price data-product-id="${escapeHtml(productId)}" data-variant-id="${escapeHtml(variantId)}" data-base-price-cents="${Math.round(price * 100)}" data-compare-at-price-cents="${Math.round(compareAtPrice * 100)}" data-price-show-from="${showFrom}">
        ${onSale ? `
          <span class="visually-hidden" data-price-compare-label>Regular price</span>
          <s class="price__compare" data-price-compare>${formatMoney(compareAtPrice, currencyCode)}</s>
        ` : ''}
        <span class="visually-hidden" data-price-current-label>${onSale ? 'Sale price' : 'Regular price'}</span>
        <span class="price__current" data-price-current>
          ${showFrom ? '<span class="price__from">From</span>' : ''}
          ${formatMoney(price, currencyCode)}
        </span>
      </div>
    `;
  };

  const renderCardImage = (image, productTitle, { className = '', eager = false } = {}) => {
    if (!image?.url) return '';

    const src = withImageWidth(image.url, 540);
    const width = image.width || 540;
    const height = image.height || 810;

    return `
      <img
        ${className ? `class="${escapeHtml(className)}"` : ''}
        data-product-image
        ${className ? '' : 'data-product-card-primary-image'}
        src="${escapeHtml(src)}"
        srcset="${escapeHtml(buildSrcset(image.url))}"
        sizes="${productImageSizes}"
        width="${width}"
        height="${height}"
        alt="${escapeHtml(image.altText || productTitle)}"
        loading="${eager ? 'eager' : 'lazy'}"
        ${eager ? 'fetchpriority="high"' : ''}
        decoding="async"
      >
    `;
  };

  const renderBadges = (product) => {
    const tagLabel = (product?.tags || []).find((tag) => String(tag).startsWith('_label_'));
    const existingLabel = product?.badges?.customLabel || (tagLabel ? String(tagLabel).replace('_label_', '') : '');
    const tags = (product?.tags || []).map((tag) => String(tag).trim().toLowerCase());
    const isBestseller = tags.includes('bestseller') || tags.includes('_label_bestseller') || String(existingLabel).trim().toLowerCase() === 'bestseller';
    let customLabel = existingLabel;
    if (isBestseller) {
      customLabel = 'BESTSELLER';
    } else if (tags.includes('new to sale')) {
      customLabel = 'NEW TO SALE';
    } else if (tags.includes('wob exclusive')) {
      customLabel = 'ONLY AT WO';
    }

    if (customLabel) {
      return `<span class="product-card__badge product-card__badge--custom">${escapeHtml(customLabel)}</span>`;
    }

    if (product?.badges?.soldOut || !product?.availableForSale) {
      return '<span class="product-card__badge">Sold out</span>';
    }

    if (product?.badges?.onSale) {
      return `<span class="product-card__badge product-card__badge--sale">${escapeHtml(product.badges.salePercent || 0)}% off</span>`;
    }

    return '';
  };

  const formatSizeLabel = (value) => {
    const normalized = String(value || '').trim().toLowerCase();

    if (normalized === 'small') return 'S';
    if (normalized === 'medium') return 'M';
    if (normalized === 'large') return 'L';

    return value;
  };

  const findVariantForSize = ({ colorOptionName, selectedColor, sizeOptionName, sizeValue, variants }) => {
    const normalizedSize = String(sizeValue || '').toLowerCase();
    const normalizedColor = String(selectedColor || '').toLowerCase();

    return variants.find((variant) => {
      if (variant.hidden) return false;
      if (String(getVariantOptionValue(variant, sizeOptionName)).toLowerCase() !== normalizedSize) return false;
      if (!colorOptionName || !normalizedColor) return true;

      return String(getVariantOptionValue(variant, colorOptionName)).toLowerCase() === normalizedColor;
    }) || null;
  };

  const renderQuickAdd = (root, product) => {
    const variants = getVisibleVariants(product);
    const selectedVariant = getSelectedVariant(product);
    const plusIcon = getIcon(root, 'plus');
    const productTitle = product?.title || 'Product';

    if (!product?.availableForSale || !selectedVariant) {
      return '<span class="product-card__quick-unavailable">Sold out</span>';
    }

    const options = product?.options || [];
    const colorOptionName = product.colorOptionIndex > -1 ? getOptionName(options[product.colorOptionIndex]) : '';
    const sizeOptionName = product.sizeOptionIndex > -1 ? getOptionName(options[product.sizeOptionIndex]) : '';
    const selectedColor = product.selectedColor || getVariantOptionValue(selectedVariant, colorOptionName);
    const sizes = Array.from(new Set(variants.map((variant) => getVariantOptionValue(variant, sizeOptionName)).filter(Boolean)));

    if (sizeOptionName && sizes.length) {
      const sizeForms = sizes.map((size) => {
        const variant = findVariantForSize({
          colorOptionName,
          selectedColor,
          sizeOptionName,
          sizeValue: size,
          variants
        });
        const available = isVariantAvailable(variant);
        const label = formatSizeLabel(size);

        return `
          <form
            class="product-card__size-form"
            method="post"
            action="/cart/add"
            data-cart-add-form
            data-product-card-size-form
            data-product-card-size-value="${escapeHtml(size)}"
            data-product-card-size-display="${escapeHtml(label)}"
          >
            <input type="hidden" name="id" value="${escapeHtml(getVariantNumericId(variant))}" data-product-card-variant-input>
            <input type="hidden" name="quantity" value="1">
            <button
              class="product-card__size-button"
              type="submit"
              data-product-card-size-button
              ${available ? '' : 'disabled'}
              aria-label="${escapeHtml(available ? `Add ${productTitle} - ${size} to bag` : `${productTitle} - ${size} unavailable`)}"
            >
              ${escapeHtml(label)}
            </button>
          </form>
        `;
      }).join('');

      return `
        <details class="product-card__quick-add">
          <summary>
            ${plusIcon}
            <span>Quick add</span>
          </summary>
          <div class="product-card__quick-options" aria-label="Quick add ${escapeHtml(productTitle)}">
            ${sizeForms}
          </div>
        </details>
      `;
    }

    return `
      <form class="product-card__quick-form" method="post" action="/cart/add" data-cart-add-form>
        <input type="hidden" name="id" value="${escapeHtml(getVariantNumericId(selectedVariant))}" data-product-card-variant-input>
        <input type="hidden" name="quantity" value="1">
        <button class="product-card__quick-submit" type="submit" aria-label="Add ${escapeHtml(productTitle)} to bag">
          ${plusIcon}
          <span>Add to cart</span>
        </button>
      </form>
    `;
  };

  const renderSwatches = (root, product) => {
    const allSwatches = window.WobSwatches?.getUniqueSwatches?.(product?.swatches) || [];
    if (allSwatches.length <= 1) return '';

    const splitSwatchLimit = Number(root.dataset.collectionSplitSwatchLimit) || 4;
    const visibleSwatchLimit = product?.splitColor ? Math.min(Math.max(splitSwatchLimit, 2), 6) : 6;
    const selectedVariant = getSelectedVariant(product);
    const options = product?.options || [];
    const colorOptionName = product.colorOptionIndex > -1 ? getOptionName(options[product.colorOptionIndex]) : '';
    const selectedColor = String(product.selectedColor || getVariantOptionValue(selectedVariant, colorOptionName) || '').toLowerCase();
    // Color cards lead with their own color so it stays visible within the shorter swatch row.
    const swatches = product?.splitColor
      ? [
        ...allSwatches.filter((swatch) => String(swatch.color || '').toLowerCase() === selectedColor),
        ...allSwatches.filter((swatch) => String(swatch.color || '').toLowerCase() !== selectedColor)
      ]
      : allSwatches;

    return `
      <div class="product-card__swatches" aria-label="Color options for ${escapeHtml(product.title)}">
        ${swatches.map((swatch, swatchIndex) => {
          const color = swatch.color || '';
          const variantId = getVariantNumericId(swatch.variantId);
          const image = swatch.image || null;
          const hoverImage = swatch.hoverImage || image;
          const hasColorImage = swatch.hasColorImage !== false && Boolean(image?.url);
          const isActive = selectedColor && String(color).toLowerCase() === selectedColor;

          return `
            <button
              class="product-card__swatch${isActive ? ' product-card__swatch--active' : ''}"
              type="button"
              data-product-card-swatch
              data-product-card-url="${escapeHtml(getCollectionProductUrl(root, swatch.url || product.url, product.handle))}"
              data-product-card-variant-id="${escapeHtml(variantId)}"
              data-product-card-color-value="${escapeHtml(color)}"
              data-swatch-tooltip="${escapeHtml(color)}"
              ${hasColorImage ? '' : 'data-product-card-image-missing="true"'}
              ${hasColorImage ? `
                data-image-src="${escapeHtml(withImageWidth(image.url, 540))}"
                data-image-srcset="${escapeHtml(buildSrcset(image.url))}"
                data-image-alt="${escapeHtml(image.altText || product.title)}"
                data-hover-image-src="${escapeHtml(withImageWidth(hoverImage?.url || image.url, 540))}"
                data-hover-image-srcset="${escapeHtml(buildSrcset(hoverImage?.url || image.url))}"
                data-hover-image-alt="${escapeHtml(hoverImage?.altText || product.title)}"
              ` : ''}
              aria-label="${escapeHtml(`${product.title} - ${color}`)}"
              aria-pressed="${isActive ? 'true' : 'false'}"
              ${swatchIndex >= visibleSwatchLimit ? 'hidden' : ''}
            >
              <span class="product-card__swatch-visual" data-swatch-value="${escapeHtml(color)}" style="${escapeHtml(getSwatchStyle(color))}"></span>
            </button>
          `;
        }).join('')}
        ${swatches.length > visibleSwatchLimit ? `<button class="product-card__swatch-more" type="button" data-product-card-swatches-expand aria-expanded="false" aria-label="Show ${swatches.length - visibleSwatchLimit} more colors for ${escapeHtml(product.title)}">+${swatches.length - visibleSwatchLimit}</button>` : ''}
      </div>
    `;
  };

  const renderSelectedColor = (product) => {
    const swatches = Array.isArray(product?.swatches) ? product.swatches : [];
    if (swatches.length <= 1) return '';

    const selectedVariant = getSelectedVariant(product);
    const options = product?.options || [];
    const colorOptionName = product.colorOptionIndex > -1 ? getOptionName(options[product.colorOptionIndex]) : '';
    const selectedColor = product.selectedColor || getVariantOptionValue(selectedVariant, colorOptionName);

    if (!selectedColor) return '';

    return `
      <p class="product-card__selected-color" data-product-card-selected-color>
        Color: <span data-product-card-selected-color-text data-swatch-label-raw="${escapeHtml(selectedColor)}">${escapeHtml(getSwatchLabel(selectedColor))}</span>
      </p>
    `;
  };

  const renderVariantsJson = (root, product) => {
    return safeJson((product?.variants || []).map((variant) => ({
      id: getVariantNumericId(variant),
      available: isVariantAvailable(variant),
      hidden: Boolean(variant.hidden),
      options: getVariantOptions(variant),
      price: Math.round(moneyAmount(variant.price) * 100),
      compare_at_price: Math.round(moneyAmount(variant.compareAtPrice) * 100),
      url: getCollectionProductUrl(root, variant.url || product.url || '', product.handle)
    })));
  };

  const normalizeMediaImage = (image) => {
    if (!image?.url) return null;

    return {
      url: image.url,
      altText: image.altText || '',
      width: image.width || null,
      height: image.height || null
    };
  };

  const renderMediaJson = (product) => {
    return safeJson({
      truncated: Boolean(product?.mediaTruncated),
      images: (product?.images || []).map(normalizeMediaImage).filter(Boolean),
      groups: (product?.mediaGroups || []).map((group) => ({
        color: group.color || '',
        images: (group.images || []).map(normalizeMediaImage).filter(Boolean)
      })).filter((group) => group.images.length)
    });
  };

  const renderMediaControls = (root, product) => {
    return `
      <div class="product-card__media-controls" data-product-card-carousel-controls hidden>
        <button
          class="product-card__media-control product-card__media-control--prev"
          type="button"
          aria-label="Previous image for ${escapeHtml(product.title)}"
          data-product-card-carousel-prev
        >
          ${getIcon(root, 'chevron-left')}
        </button>
        <button
          class="product-card__media-control product-card__media-control--next"
          type="button"
          aria-label="Next image for ${escapeHtml(product.title)}"
          data-product-card-carousel-next
        >
          ${getIcon(root, 'chevron-right')}
        </button>
      </div>
    `;
  };

  const renderWorkerProductCard = (root, product, index) => {
    const productId = product.numericId || getVariantNumericId(product.id) || product.handle || index;
    const cardId = `WorkerProductCard-${productId}-${index}`;
    const productUrl = getCollectionProductUrl(root, product.url || `/products/${product.handle}`, product.handle);
    const imageRatio = root.dataset.imageRatio || 'portrait';
    const featuredImage = product.featuredImage || null;
    const secondaryImage = root.dataset.showSecondaryImage === 'true' ? product.secondaryImage : null;
    const showVendor = root.dataset.showVendor === 'true' && product.vendor;

    return `
      <article
        class="product-card product-card--${escapeHtml(imageRatio)}"
        data-product-id="${escapeHtml(productId)}"
        ${product.cardKey ? `data-product-card-key="${escapeHtml(product.cardKey)}" data-product-card-color="${escapeHtml(product.splitColor || '')}"` : ''}
        data-product-handle="${escapeHtml(product.handle || '')}"
        data-product-title="${escapeHtml(product.title || '')}"
        data-collection-result-position="${Number(product.recommendation?.productPosition || index || 0)}"
        data-collection-card-position="${Number(index || 0)}"
        data-variant-id="${escapeHtml(getVariantNumericId(product.selectedVariantId) || '')}"
        data-collection-worker-product="true"
        data-product-card-size-option-index="${Number(product.sizeOptionIndex ?? -1)}"
        data-product-card-color-option-index="${Number(product.colorOptionIndex ?? -1)}"
      >
        <div class="product-card__media-shell">
          <a class="product-card__media" href="${escapeHtml(productUrl)}" aria-labelledby="${escapeHtml(cardId)}-title" data-product-card-link>
            ${featuredImage?.url ? renderCardImage(featuredImage, product.title, { eager: index <= 4 }) : '<div class="product-card__placeholder" aria-hidden="true"></div>'}
            ${secondaryImage?.url && secondaryImage.url !== featuredImage?.url ? renderCardImage(secondaryImage, product.title, { className: 'product-card__secondary-image' }) : ''}
          </a>
          ${renderMediaControls(root, product)}

          <div class="product-card__badges" aria-hidden="true">
            ${renderBadges(product)}
          </div>

          <div class="product-card__image-actions">
            ${renderQuickAdd(root, product)}
          </div>
        </div>

        <div class="product-card__content">
          ${showVendor ? `<p class="product-card__vendor">${escapeHtml(product.vendor)}</p>` : ''}
          <h3 class="product-card__title" id="${escapeHtml(cardId)}-title">
            <a href="${escapeHtml(productUrl)}" data-product-card-link>${escapeHtml(product.title)}</a>
          </h3>
          <div class="product-card__details">
            ${renderPrice(root, product)}
          </div>
          ${renderSelectedColor(product)}
          ${renderSwatches(root, product)}
        </div>

        <script type="application/json" data-product-card-variants>${renderVariantsJson(root, product)}</script>
        <script type="application/json" data-product-card-media>${renderMediaJson(product)}</script>
      </article>
    `;
  };

  const createProductFragment = (root, products, startIndex = 0) => {
    const template = document.createElement('template');

    template.innerHTML = products.map((product, index) => {
      return renderWorkerProductCard(root, product, startIndex + index + 1);
    }).join('');

    return template.content;
  };

  const createProductSkeletonFragment = (count, attributeName = 'data-collection-loading-skeleton') => {
    const template = document.createElement('template');
    const cardCount = Math.max(1, Math.min(Number(count) || 5, 50));

    template.innerHTML = Array.from({ length: cardCount }, () => `
      <article class="product-card product-card--portrait product-card--skeleton collection-worker-skeleton" ${attributeName} aria-hidden="true">
        <div class="product-card__media-shell">
          <div class="product-card__media product-card__skeleton-media"></div>
          <div class="product-card__image-actions product-card__skeleton-action"></div>
        </div>
        <div class="product-card__content">
          <span class="product-card__skeleton-line product-card__skeleton-line--title"></span>
          <span class="product-card__skeleton-line product-card__skeleton-line--price"></span>
          <span class="product-card__skeleton-line product-card__skeleton-line--swatches"></span>
        </div>
      </article>
    `).join('');

    return template.content;
  };

  const getCollectionSkeletonCount = (root) => {
    return Math.max(1, Math.min(Number(root?.dataset.collectionPageSize) || 40, 50));
  };

  const removeCollectionLoadingSkeletons = (scope) => {
    scope?.querySelectorAll('[data-collection-loading-skeleton]').forEach((skeleton) => {
      skeleton.remove();
    });
  };

  const appendCollectionLoadingSkeletons = (root, grid) => {
    if (!grid) return;

    removeCollectionLoadingSkeletons(grid);
    grid.appendChild(createProductSkeletonFragment(getCollectionSkeletonCount(root)));
  };

  const appendFilterValue = (filters, name, value) => {
    if (!name || !value) return;
    if (!filters[name]) filters[name] = [];

    filters[name].push(value);
  };

  const getWorkerFiltersFromLocation = () => {
    const params = new URLSearchParams(window.location.search);
    const filters = {};
    const price = {};
    let unsupported = false;

    const isWorkerColorFilterParam = (key) => {
      const normalized = String(key || '').toLowerCase().replace(/[_-]+/g, '.');

      return normalized === 'filter.v.option.color'
        || normalized === 'filter.v.option.colour'
        || normalized.endsWith('.ss.filter.color')
        || normalized.endsWith('.custom.color.filter')
        || normalized.endsWith('.color.filter');
    };

    params.forEach((value, key) => {
      if (!key.startsWith('filter.')) return;

      if (isWorkerColorFilterParam(key)) {
        appendFilterValue(filters, 'Color', value);
        return;
      }

      if (key === 'filter.v.price.gte') {
        if (value !== '') price.min = value;
        return;
      }
      if (key === 'filter.v.price.lte') {
        if (value !== '') price.max = value;
        return;
      }
      if (key === 'filter.v.availability') {
        if (value === '1') appendFilterValue(filters, 'Availability', 'available');
        else unsupported = true;
        return;
      }
      if (key.startsWith('filter.v.option.')) {
        appendFilterValue(filters, key.replace('filter.v.option.', ''), value);
        return;
      }

      unsupported = true;
    });

    if (price.min || price.max) {
      filters.price = price;
    }

    return {
      filters,
      unsupported
    };
  };

  const getWorkerSortKey = (root) => {
    return new URLSearchParams(window.location.search).get('sort_by') || root.dataset.collectionSortKey || 'recommended';
  };

  const updateCollectionCount = (root, totalResults) => {
    if (!Number.isFinite(Number(totalResults))) return;

    const section = root.closest('.collection-template') || document;
    const formattedCount = new Intl.NumberFormat(document.documentElement.lang || 'en-US').format(Number(totalResults));

    section.querySelectorAll('[data-collection-count-number]').forEach((element) => {
      element.textContent = formattedCount;
    });
  };

  const isInfiniteScrollTriggerNearViewport = (trigger) => {
    if (!(trigger instanceof Element)) return false;

    const rect = trigger.getBoundingClientRect();
    const viewportHeight = window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight || 0;

    return rect.top <= viewportHeight + infiniteScrollPreloadMargin && rect.bottom >= -infiniteScrollPreloadMargin;
  };

  const initNativeInfiniteScroll = (root) => {
    if (!supportsNativeInfiniteScroll) return;

    const grid = root.querySelector('[data-collection-products]');
    const pagination = root.querySelector('[data-collection-pagination]');
    const trigger = root.querySelector('[data-collection-infinite-trigger]');
    const status = root.querySelector('[data-collection-infinite-status]');
    const sectionId = root.dataset.sectionId || '';
    let nextLink = getInfiniteScrollNextLink(root);
    let isLoading = false;
    let observer = null;
    let queuedVisibleLoad = false;

    if (!grid || !pagination || !trigger || !nextLink) return;

    const showFallbackPagination = (message) => {
      root.classList.remove('collection-infinite-scroll--enabled');
      root.classList.remove('collection-infinite-scroll--loading');
      root.classList.add('collection-infinite-scroll--error');
      removeCollectionLoadingSkeletons(grid);
      grid.removeAttribute('aria-busy');
      setInfiniteScrollStatus(status, message);
      observer?.disconnect();
    };

    const getNextRoot = (documentFragment) => {
      const nextRoots = Array.from(documentFragment.querySelectorAll('[data-collection-infinite-scroll]'));

      return nextRoots.find((candidateRoot) => candidateRoot.dataset.sectionId === sectionId) || nextRoots[0] || null;
    };

    const loadNextPage = async () => {
      if (isLoading || !nextLink) return;

      const nextUrl = nextLink.href;

      isLoading = true;
      root.classList.add('collection-infinite-scroll--loading');
      grid.setAttribute('aria-busy', 'true');
      appendCollectionLoadingSkeletons(root, grid);
      setInfiniteScrollStatus(status, 'Loading more styles...');

      try {
        const response = await fetch(nextUrl, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error(`Unable to load ${nextUrl}`);
        }

        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const nextRoot = getNextRoot(parsedDocument);
        const nextGrid = nextRoot?.querySelector('[data-collection-products]');
        const nextPagination = nextRoot?.querySelector('[data-collection-pagination]');
        const nextProducts = Array.from(nextGrid?.children || []).filter((child) => {
          return child instanceof HTMLElement
            && !child.classList.contains('empty-state')
            && !child.hasAttribute('data-collection-worker-skeleton');
        });

        if (!nextRoot || !nextGrid || !nextProducts.length) {
          throw new Error(`No products found in ${nextUrl}`);
        }

        const fragment = document.createDocumentFragment();

        nextProducts.forEach((productCard) => {
          normalizeLoadedProductImages(productCard);
          fragment.appendChild(productCard);
        });

        removeCollectionLoadingSkeletons(grid);
        grid.appendChild(fragment);
        pagination.innerHTML = nextPagination?.innerHTML || '';
        nextLink = getInfiniteScrollNextLink(root);

        if (nextLink) {
          setInfiniteScrollStatus(status, '');
        } else {
          root.classList.add('collection-infinite-scroll--complete');
          setInfiniteScrollStatus(status, 'All styles loaded.');
          observer?.disconnect();
        }
      } catch (error) {
        nextLink = null;
        showFallbackPagination('More styles could not load automatically. Use pagination to continue.');
      } finally {
        isLoading = false;
        root.classList.remove('collection-infinite-scroll--loading');
        removeCollectionLoadingSkeletons(grid);
        grid.removeAttribute('aria-busy');
        queueVisibleNativeLoad();
      }
    };

    const queueVisibleNativeLoad = () => {
      if (!nextLink || isLoading || queuedVisibleLoad) return;

      queuedVisibleLoad = true;
      window.requestAnimationFrame(() => {
        queuedVisibleLoad = false;

        if (nextLink && !isLoading && isInfiniteScrollTriggerNearViewport(trigger)) {
          loadNextPage();
        }
      });
    };

    observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        loadNextPage();
      }
    }, {
      rootMargin: infiniteScrollRootMargin
    });

    root.classList.add('collection-infinite-scroll--enabled');
    observer.observe(trigger);
  };

  const initWorkerInfiniteScroll = (root) => {
    const endpoint = root.dataset.collectionWorkerEndpoint || '';
    const enabled = root.dataset.collectionWorkerEnabled === 'true';
    const workerPricingCompatible = window.WobWorkerMarket?.isPricingCompatible?.() !== false;
    const grid = root.querySelector('[data-collection-products]');
    const trigger = root.querySelector('[data-collection-infinite-trigger]');
    const status = root.querySelector('[data-collection-infinite-status]');
    const filterState = getWorkerFiltersFromLocation();

    if (!supportsWorkerInfiniteScroll || !enabled || !workerPricingCompatible || !endpoint || !grid || !trigger || filterState.unsupported) {
      return false;
    }

    let nextCursor = null;
    let isLoading = false;
    let observer = null;
    let renderedCount = 0;
    let queuedVisibleLoad = false;

    const experiment = window.WobCollectionExperiments?.create(root);
    let nativeFallbackNodes = [...grid.childNodes];

    const removeWorkerSkeletons = () => {
      root.querySelectorAll('[data-collection-worker-skeleton]').forEach((skeleton) => {
        skeleton.remove();
      });
    };

    const revealNativeFallback = () => {
      removeWorkerSkeletons();
      removeCollectionLoadingSkeletons(root);
      root.classList.remove('collection-infinite-scroll--worker-ready');
      root.classList.remove('collection-infinite-scroll--enabled');
      root.classList.remove('collection-infinite-scroll--loading');
      root.classList.add('collection-infinite-scroll--fallback');
      grid.removeAttribute('aria-busy');
      setInfiniteScrollStatus(status, '');
    };

    const setLoading = (loading, message = null) => {
      isLoading = loading;
      root.classList.toggle('collection-infinite-scroll--loading', loading);
      if (loading) {
        grid.setAttribute('aria-busy', 'true');
      } else {
        grid.removeAttribute('aria-busy');
      }
      if (message !== null) {
        setInfiniteScrollStatus(status, message);
      }
    };

    const requestPage = async ({ cursor = null } = {}) => {
      const body = {
        collectionId: root.dataset.collectionId || '',
        collectionHandle: root.dataset.collectionHandle || '',
        pageSize: Number(root.dataset.collectionPageSize || 40),
        sortKey: getWorkerSortKey(root),
        filters: filterState.filters
      };

      // Color cards are enabled in WOB App; 'auto' lets the Worker apply that setting to this grid.
      body.splitColors = 'auto';
      if (cursor) body.cursor = cursor;
      if (experiment) await experiment.ready();
      const experimentRequest = experiment?.request(body.sortKey, body.filters);
      if (experimentRequest) body.experimentRequest = experimentRequest;

      const response = await fetch(`${endpoint.replace(/\/$/, '')}/collections/products`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      const payload = await response.json().catch(() => null);

      if (!response.ok || !payload?.ok || payload?.fallback?.recommended) {
        const error = new Error(payload?.fallback?.reason || 'collection-worker-unavailable');
        error.restartSharedBoosts = payload?.restartRequired === true
          && ['collection-boosts-changed', 'collection-layout-changed'].includes(payload?.fallback?.reason);
        throw error;
      }

      // Never render an assigned arm before this theme can measure its visits.
      if (payload.experiment != null && !window.WobCollectionExperiments) {
        throw new Error('collection-experiment-client-unavailable');
      }
      if (experiment) experiment.accept(payload);
      else window.WobCollectionExperiments?.assertCompatibleResponse(payload);

      return payload;
    };

    const showNativeFallback = () => {
      if (nativeFallbackNodes) grid.replaceChildren(...nativeFallbackNodes);
      observer?.disconnect();
      nextCursor = null;
      revealNativeFallback();
      initNativeInfiniteScroll(root);
    };

    const renderPayload = (payload, { replace = false } = {}) => {
      const products = Array.isArray(payload.products) ? payload.products : [];

      if (replace) {
        grid.replaceChildren();
        renderedCount = 0;
      }

      if (products.length) {
        removeCollectionLoadingSkeletons(grid);
        const fragment = createProductFragment(root, products, renderedCount);
        experiment?.bindCards(fragment, payload.experiment);
        grid.appendChild(fragment);
        renderedCount += products.length;
      } else if (replace) {
        const emptyState = document.createElement('p');

        emptyState.className = 'empty-state';
        emptyState.textContent = 'No products found in this collection.';
        grid.appendChild(emptyState);
      }

      nextCursor = payload.pageInfo?.nextCursor || null;
      // "N styles" counts products even when each color has its own card.
      updateCollectionCount(root, payload.productTotalResults ?? payload.totalResults);
      updateCustomColorFilterCounts(root, payload.facets?.Color || {});
      root.classList.add('collection-infinite-scroll--worker-ready');
      root.classList.add('collection-infinite-scroll--enabled');

      if (!nextCursor) {
        root.classList.add('collection-infinite-scroll--complete');
        setInfiniteScrollStatus(status, 'All styles loaded.');
        observer?.disconnect();
      } else {
        root.classList.remove('collection-infinite-scroll--complete');
        setInfiniteScrollStatus(status, '');
      }
    };

    const loadWorkerPage = async ({ replace = false } = {}) => {
      if (isLoading) return;

      setLoading(true, replace ? 'Loading recommended styles...' : 'Loading more styles...');
      if (!replace) appendCollectionLoadingSkeletons(root, grid);

      try {
        let payload;
        try {
          payload = await requestPage({ cursor: replace ? null : nextCursor });
        } catch (error) {
          if (replace || !error.restartSharedBoosts) throw error;
          // A shared boost started/stopped between pages. Restart once instead
          // of mixing two rankings or falling back to an unboosted native grid.
          payload = await requestPage();
          replace = true;
        }

        removeCollectionLoadingSkeletons(grid);
        renderPayload(payload, { replace });
        experiment?.rendered(true);
        nativeFallbackNodes = null;
      } catch (error) {
        experiment?.rendered(false);
        removeCollectionLoadingSkeletons(grid);
        if (replace) {
          showNativeFallback();
        } else {
          nextCursor = null;
          root.classList.remove('collection-infinite-scroll--enabled');
          root.classList.add('collection-infinite-scroll--error');
          setInfiniteScrollStatus(status, 'More styles could not load automatically. Use pagination to continue.');
          observer?.disconnect();
        }
      } finally {
        setLoading(false, null);
        removeCollectionLoadingSkeletons(grid);
        queueVisibleWorkerLoad();
      }
    };

    const queueVisibleWorkerLoad = () => {
      if (!nextCursor || isLoading || queuedVisibleLoad) return;

      queuedVisibleLoad = true;
      window.requestAnimationFrame(() => {
        queuedVisibleLoad = false;

        if (nextCursor && !isLoading && isInfiniteScrollTriggerNearViewport(trigger)) {
          loadWorkerPage();
        }
      });
    };

    observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting) && nextCursor) {
        loadWorkerPage();
      }
    }, {
      rootMargin: infiniteScrollRootMargin
    });

    loadWorkerPage({ replace: true }).then(() => {
      if (nextCursor) observer.observe(trigger);
    });

    return true;
  };

  infiniteScrollSections.forEach((root) => {
    if (!initWorkerInfiniteScroll(root)) {
      if (root.dataset.collectionWorkerEnabled === 'true') {
        root.querySelectorAll('[data-collection-worker-skeleton]').forEach((skeleton) => {
          skeleton.remove();
        });
        root.classList.add('collection-infinite-scroll--fallback');
      }
      initNativeInfiniteScroll(root);
    }
  });

  const forms = document.querySelectorAll('[data-collection-filter-form]');
  if (!forms.length) return;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'summary',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  forms.forEach((form) => {
    const shell = form.querySelector('[data-collection-drawer-shell]');
    const drawer = form.querySelector('[data-collection-drawer]');
    const openButtons = form.querySelectorAll('[data-collection-drawer-open]');
    const closeButtons = form.querySelectorAll('[data-collection-drawer-close]');
    const sortCurrent = form.querySelector('[data-collection-sort-current]');
    const priceRanges = form.querySelectorAll('[data-collection-price-range]');
    const applyButton = form.querySelector('.collection-toolbar__apply');
    let lastActiveElement = null;
    let closeTimer = null;

    if (!shell || !drawer || !openButtons.length) return;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const parseNumber = (value, fallback = 0) => {
      const number = Number.parseFloat(value);

      return Number.isFinite(number) ? number : fallback;
    };

    const formatQueryValue = (value) => {
      const rounded = Math.round(value * 100) / 100;

      return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    };

    const formatMoney = (value, currencyCode) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currencyCode || 'USD',
          maximumFractionDigits: Number.isInteger(value) ? 0 : 2
        }).format(value);
      } catch (error) {
        return `$${formatQueryValue(value)}`;
      }
    };

    const updatePriceRange = (priceRange, source = '') => {
      const minLimit = parseNumber(priceRange.dataset.priceMin, 0);
      const maxLimit = parseNumber(priceRange.dataset.priceMax, minLimit);
      const minRange = priceRange.querySelector('[data-price-min-range]');
      const maxRange = priceRange.querySelector('[data-price-max-range]');
      const minInput = priceRange.querySelector('[data-price-min-input]');
      const maxInput = priceRange.querySelector('[data-price-max-input]');
      const minNumber = priceRange.querySelector('[data-price-min-number]');
      const maxNumber = priceRange.querySelector('[data-price-max-number]');
      const minLabel = priceRange.querySelector('[data-price-min-label]');
      const maxLabel = priceRange.querySelector('[data-price-max-label]');
      const range = Math.max(maxLimit - minLimit, 1);

      if (!minRange || !maxRange || !minInput || !maxInput) return;

      let minValue = clamp(parseNumber(source === 'minNumber' ? minNumber?.value : minRange.value, minLimit), minLimit, maxLimit);
      let maxValue = clamp(parseNumber(source === 'maxNumber' ? maxNumber?.value : maxRange.value, maxLimit), minLimit, maxLimit);

      if (minValue > maxValue) {
        if (source === 'maxRange' || source === 'maxNumber') {
          minValue = maxValue;
        } else {
          maxValue = minValue;
        }
      }

      const minTextValue = formatQueryValue(minValue);
      const maxTextValue = formatQueryValue(maxValue);
      const start = ((minValue - minLimit) / range) * 100;
      const end = ((maxValue - minLimit) / range) * 100;

      minRange.value = minTextValue;
      maxRange.value = maxTextValue;
      minRange.setAttribute('aria-valuetext', formatMoney(minValue, priceRange.dataset.currencyCode));
      maxRange.setAttribute('aria-valuetext', formatMoney(maxValue, priceRange.dataset.currencyCode));

      if (minNumber) minNumber.value = minTextValue;
      if (maxNumber) maxNumber.value = maxTextValue;
      if (minLabel) minLabel.textContent = formatMoney(minValue, priceRange.dataset.currencyCode);
      if (maxLabel) maxLabel.textContent = formatMoney(maxValue, priceRange.dataset.currencyCode);

      minInput.value = minValue <= minLimit ? '' : minTextValue;
      maxInput.value = maxValue >= maxLimit ? '' : maxTextValue;

      priceRange.style.setProperty('--price-range-start', `${start}%`);
      priceRange.style.setProperty('--price-range-end', `${end}%`);
    };

    priceRanges.forEach((priceRange) => {
      const minRange = priceRange.querySelector('[data-price-min-range]');
      const maxRange = priceRange.querySelector('[data-price-max-range]');
      const minNumber = priceRange.querySelector('[data-price-min-number]');
      const maxNumber = priceRange.querySelector('[data-price-max-number]');

      updatePriceRange(priceRange);

      minRange?.addEventListener('input', () => updatePriceRange(priceRange, 'minRange'));
      maxRange?.addEventListener('input', () => updatePriceRange(priceRange, 'maxRange'));
      minNumber?.addEventListener('input', () => updatePriceRange(priceRange, 'minNumber'));
      maxNumber?.addEventListener('input', () => updatePriceRange(priceRange, 'maxNumber'));
    });

    updateCustomColorFilterState(form);

    const getFocusableElements = () => {
      return Array.from(drawer.querySelectorAll(focusableSelector)).filter((element) => {
        return element instanceof HTMLElement && element.offsetParent !== null;
      });
    };

    const setExpanded = (expanded) => {
      openButtons.forEach((button) => {
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    };

    const closeOpenGroups = () => {
      drawer.querySelectorAll('details[open]').forEach((details) => {
        details.open = false;
      });
    };

    const setFilterSubmitLoading = (submitter) => {
      const button = submitter instanceof HTMLElement ? submitter : applyButton;

      if (!button) return;

      form.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      if ('disabled' in button) {
        button.disabled = true;
      }
    };

    const openDrawer = () => {
      window.clearTimeout(closeTimer);
      lastActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      shell.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      setExpanded(true);
      document.documentElement.classList.add('collection-filter-drawer-is-open');
      document.body.classList.add('collection-filter-drawer-is-open');

      window.requestAnimationFrame(() => {
        shell.classList.add('collection-filter-drawer--open');
        const focusTarget = drawer.querySelector('.collection-filter-drawer__close') || drawer;
        focusTarget.focus({ preventScroll: true });
      });
    };

    const closeDrawer = ({ restoreFocus = true } = {}) => {
      shell.classList.remove('collection-filter-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      setExpanded(false);
      document.documentElement.classList.remove('collection-filter-drawer-is-open');
      document.body.classList.remove('collection-filter-drawer-is-open');
      closeOpenGroups();

      closeTimer = window.setTimeout(() => {
        shell.hidden = true;
      }, 220);

      if (restoreFocus && lastActiveElement) {
        lastActiveElement.focus({ preventScroll: true });
      }
    };

    const trapFocus = (event) => {
      if (event.key !== 'Tab' || shell.hidden) return;

      const focusableElements = getFocusableElements();
      if (!focusableElements.length) {
        event.preventDefault();
        drawer.focus({ preventScroll: true });
        return;
      }

      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
        return;
      }

      if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', openDrawer);
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closeDrawer());
    });

    form.addEventListener('change', (event) => {
      const input = event.target;

      if (!(input instanceof HTMLInputElement)) return;

      if (input.matches('[data-custom-color-filter]')) {
        input.closest('[data-custom-color-filter-label]')?.classList.toggle('filter-swatch--active', input.checked);
      }

      if (input.name !== 'sort_by' || !sortCurrent) return;

      sortCurrent.textContent = input.dataset.sortLabel || input.value;
    });

    form.addEventListener('submit', (event) => {
      priceRanges.forEach((priceRange) => updatePriceRange(priceRange));
      setFilterSubmitLoading(event.submitter);
    });

    document.addEventListener('keydown', (event) => {
      if (shell.hidden) return;

      trapFocus(event);

      if (event.key !== 'Escape') return;
      if (drawer.querySelector('details[open]')) return;

      event.preventDefault();
      closeDrawer();
    });
  });
})();
